import { LoanService, AuthService } from '@/utils/service'
export const getSignInfo = (applyId) => {
    return new LoanService({
        url: '/loan/app/v5/loan/detail/v3',
        method: 'get',
        data: {
            applyId: applyId
        }
    })
}

export const getContractList = (applyId, type) => {
    return new LoanService({
        url: '/loan/app/user/v5/contract/list',
        method: 'get',
        data: {
            applyId: applyId,
            type: type || 'Borrowing_Sign'
        }
    })
}
const caller = () => {
    let ua = window.navigator.userAgent.toLowerCase();
    let device = 'Touch'
    if (ua.indexOf('iphone'.toLowerCase()) > -1 || ua.indexOf('ipad'.toLowerCase()) > -1 || ua.indexOf('ipod'.toLowerCase()) > -1) {
        device = 'IOS';
    }
    if (ua.indexOf('android'.toLowerCase()) > -1) {
        device = 'Android';
    }
    if (ua.indexOf('micromessenger') > -1) {
        device = 'WeChat';
    }
    let map = {
        Web: 0,
        Android: 1,
        IOS: 2,
        Touch: 3,
        Auto: 4,
        WeChat: 5,
        JmAppAndroid: 11,
        JmAppIOS: 12,
        DmAppAndroid: 13,
        DmAppIOS: 14,
        JimuDaikuan: 20,
        HzAppIOS: 15,
        HzAppAndroid: 16,
        Dm2AppIOS: 17
    }
    return map[device]
}
export const createLoan = (userCookieId = Date.now(), position = '0, 0') => {
    return new LoanService({
        url: '/loan/app/v5/loan/v2',
        method: 'post',
        data: {
            userCookieId,
            position,
            caller: caller()
        }
    })
}
export const loanConfirm = (params = {
    applyId: '',
    applyBalance: 0,
    applyDays: 0,
    insuranceOn: false
}) => {
    return new LoanService({
        url: '/loan/app/v5/loan/confirm',
        method: 'post',
        data: params
    })
}
export const sign = (params = {
    applyId: 0,
    purpose: 1
}) => {
    return new LoanService({
        url: '/loan/app/v5/loan/sign/v3',
        method: 'post',
        data: params
    })
}

export const schedules = (applyId) => {
    return new LoanService({
        url: '/loan/loan/v4/preview/repayment/schedule',
        method: 'get',
        data: {
            applyId: applyId
        }
    })
}
export const getContractInfo = (params = {
    applyId: 0,
    contractType: 0
}) => {
    return new LoanService({
        url: '/loan/contract/v1/html',
        method: 'get',
        data: params
    })
}
export const uploadile = (params = {
    applyId: 0,
    fileType: 1,
    file: ''
}) => {
    return new AuthService({
        url: '/api/wallet/photo/upload',
        method: 'post',
        transformRequest: [function(data, headers) {
            headers['Content-Type'] = 'multipart/form-data'
            var formData = new FormData();
            formData.append('productId', 'DM-QBXJ');
            formData.append('applyId', params.applyId);
            formData.append('fileType', params.fileType);
            formData.append('file', params.file);
            return formData
        }]
    })
}
export const uploadFaceFile = (params = {
    applyId: 0,
    userId: 0,
    file: ''
}) => {
    return new AuthService({
        url: '/api/wallet/face/upload',
        method: 'post',
        transformRequest: [function(data, headers) {
            headers['Content-Type'] = 'multipart/form-data'
            var formData = new FormData();
            formData.append('productId', 'DM-QBXJ');
            formData.append('applyId', params.applyId);
            formData.append('fileType', 3);
            formData.append('file', params.file);
            formData.append('userId', params.userId);
            return formData
        }]
    })
}
export const initSupplementInfo = (applyId) => {
    return new AuthService({
        url: '/api/apply/patch/info/xinwang',
        method: 'get',
        data: {
            applyId: applyId
        }
    })
}
export const saveSupplementInfo = (params = {
    applyId: 0,
    tokenKey: '',
    education: 0,
    homeSituation: 0
}) => {
    return new AuthService({
        url: '/api/apply/patch/info/xinwang',
        method: 'post',
        data: params
    })
}
export const skipIdCard = (applyId) => {
    return new LoanService({
        url: '/loan/loan/v4/skip/idcardocr',
        method: 'post',
        data: {
            applyId: applyId
        }
    })
}
export const photoVerifySubmit = (applyId) => {
    return new LoanService({
        url: '/loan/user/ext/v1/idCard/check/result',
        method: 'post',
        data: {
            applyId: applyId
        }
    })
}
export const livingCheck = (params = {
    userId: 0,
    applyId: 0,
    callbackUrl: '',
}) => {
    return new LoanService({
        url: '/loan/user/ext/v1/living/check',
        method: 'post',
        data: {
            userId: params.userId,
            applyId: params.applyId,
            callbackUrl: params.callbackUrl,
        }
    })
}
export const extdata = (params = { applyId: 0, userId: 0 }) => {
    return new LoanService({
        url: '/loan/loan/v4/xinwang/extdata',
        method: 'get',
        data: {
            applyId: params.applyId,
            userId: params.userId,
        }
    })
}
export const getExtShow = (params = { applyId: 0, userId: 0 }) => {
    return new LoanService({
        url: '/loan/loan/v4/ext/show',
        method: 'get',
        data: params
    })
}
export const submitExtData = (data = { applyId: 0, userId: 0 }) => {
    return new LoanService({
        url: '/loan/loan/v4/ext/data',
        method: 'post',
        data,
    })
}
export const getGPS = () => {
    return new AuthService({
        url: '/api/apply/xinwang/gps',
        method: 'get'
    })
}
export const getWithdrawUrl = (params = {
    applyId: 0,
    balance: 0,
    term: 0,
    purpose: '',
    callback: '',
    source: 'h5_wallet'
}) => {
    return new AuthService({
        url: '/api/user/withdraw/bind/url',
        method: 'post',
        data: params
    })
}
export const getCmbcUrlForSign = (params = {
    applyId: 0,
    balance: 0,
    term: 0,
    purpose: '',
    source: 'h5_wallet_sign' // 2 表示开户成功之后立即签约
}) => {
    return new AuthService({
        url: '/api/apply/cmbc/url/contract',
        method: 'post',
        data: params
    })
}
export const getPlanList = (params = {
    applyId: 0
}) => {
    return new LoanService({
        url: '/loan/loan/v4/preview/repayment/schedule',
        method: 'get',
        data: params
    })
}
export const getLoanResult = (params = {
    applyId: 0
}) => {
    return new LoanService({
        url: '/loan/app/v4/loan/status',
        method: 'get',
        needLoading: false,
        data: {
            applyId: params.applyId
        }
    })
}
export const getLastPaymentInfo = () => {
    return new LoanService({
        url: '/loan/app/v5/loan/recommend/info',
        method: 'post'
    })
}
export const getLoanLogInfo = (params = {
    applyId: 0
}) => {
    return new LoanService({
        url: '/loan/app/user/v4/repayment/list',
        method: 'get',
        data: {
            applyID: params.applyId
        }
    })
}

// 获取loan站配置
export const getLoanConfig = () => {
    return new LoanService({
        url: '/loan/config/v1/list',
        method: 'post',
    })
}